import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62861024"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" })
], -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 24 24" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" })
], -1 /* HOISTED */))
const _hoisted_3 = { class: "calendar_months--container" }
const _hoisted_4 = {
  colspan: "7",
  class: "month--title"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "day--marker"
}
const _hoisted_7 = { class: "day--title" }
const _hoisted_8 = { class: "calendar--messages" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_material_button = _resolveComponent("material-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "calendar--container",
    style: _normalizeStyle(_ctx.containerStyles)
  }, [
    _createVNode(_component_material_button, {
      class: _normalizeClass(["calendar--navigation calendar--navigation-prev", {'calendar--navigation-hide': _ctx.isFirstMonthShowing}]),
      label: "",
      type: "anchor",
      href: "#",
      icon: "",
      onClick: _withModifiers(_ctx.setPreviousVisibleMonths, ["stop","prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick", "class"]),
    _createVNode(_component_material_button, {
      class: _normalizeClass(["calendar--navigation calendar--navigation-next", {'calendar--navigation-hide': _ctx.isLastMonthShowing}]),
      label: "",
      type: "anchor",
      href: "#",
      icon: "",
      onClick: _withModifiers(_ctx.setNextVisibleMonths, ["stop","prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick", "class"]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, monthIndex) => {
        return _withDirectives((_openBlock(), _createElementBlock("table", {
          key: month.key,
          class: "month--container"
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(month.title), 1 /* TEXT */)
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.language.en.daysMin, (dayTitle, dayIndex) => {
                return (_openBlock(), _createElementBlock("th", { key: dayIndex }, _toDisplayString(dayTitle), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(month.weeks, (week) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: week.key
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week.days, (day) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: day.key,
                    class: _normalizeClass(["day--container", _ctx.dayClasses(day)]),
                    onClick: ($event: any) => (_ctx.setSelectedDate(day, true))
                  }, [
                    (_ctx.isDayCheckInOrOut(day))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(day.title), 1 /* TEXT */)
                  ], 10 /* CLASS, PROPS */, _hoisted_5))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])), [
          [_vShow, _ctx.visibleMonths.indexOf(monthIndex) !== -1]
        ])
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createElementVNode("ul", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, messageType) => {
        return _withDirectives((_openBlock(), _createElementBlock("li", {
          key: messageType,
          innerHTML: message.html
        }, null, 8 /* PROPS */, _hoisted_9)), [
          [_vShow, message.isActive]
        ])
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 4 /* STYLE */))
}